import { render, staticRenderFns } from "./AdminCellDialogTextMultiline.vue?vue&type=template&id=7f9fd0c2&"
import script from "./AdminCellDialogTextMultiline.vue?vue&type=script&lang=js&"
export * from "./AdminCellDialogTextMultiline.vue?vue&type=script&lang=js&"
import style0 from "./AdminCellDialogTextMultiline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VEditDialog,VTextarea})
